module.exports = __webpack_public_path__ + "assets/bc669d8d9df4276b3becf32b23d1021b.svg";